export default "__VITE_ASSET__DVsqNEUY__"